import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches running jobs for a specific search query.
 * @param {string} prospectQueryId - UUID of the search query
 * @returns {Promise<{data: Array<Object>, error: Error|null}>}
 */
export const fetchJobsByProspectQueryId = async (prospectQueryId) => {
	if (!prospectQueryId) return { data: [], error: null };

	try {
		const result = await fetcher(`/api/v1/leads/jobs?prospectQueryId=${prospectQueryId}`);
		return { data: result.jobs ?? [], error: null };
	} catch (error) {
		return { data: [], error };
	}
};

/**
 * Fetches the progress of a backend job.
 * @param {string} queueName - Name of the queue (e.g. 'contactEnrichment')
 * @param {string} jobId - Bull job ID
 * @returns {Promise<Object>}
 */
export const fetchJobProgress = async (queueName, jobId) => {
	if (!queueName || !jobId) {
		throw new Error('Queue name and job ID are required');
	}

	return await fetcher(`/api/v1/platform/jobs/${queueName}/${jobId}/progress`, {
		method: 'GET',
	});
};

/**
 * Determines the queue name based on the job type.
 * Returns null for job types without a pollable queue — callers must skip
 * progress polling then and render from the job list status instead.
 * @param {string} jobType - Type of the job (e.g. 'googleMapsScraper', 'contactEnrichment')
 * @returns {string|null}
 */
export const getQueueNameForJobType = (jobType) => {
	const queueMap = {
		// Lead scraper jobs
		googleMapsScraper: 'googleMapsScraper',
		localHrSearch: 'localHrSearch',
		contactEnrichment: 'contactEnrichment',
		companyAnalysis: 'companyAnalysis',
	};

	return queueMap[jobType] || null;
};
